import { Busy } from '@/components/busy';
import { Button } from '@/components-new/button';
import { Dialog, DialogActions, DialogBody, DialogTitle } from '@/components-new/dialog';
import { MarketBasketDrugPackaging } from '@/features/market-baskets/types/market-basket';

type DeleteNdcsDialogProps = {
  open: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  selectedDrugPackagings?: MarketBasketDrugPackaging[];
  busy?: boolean;
};

export const DeleteNdcsDialog = ({ busy, onCancel, onSubmit, open, selectedDrugPackagings = [] }: DeleteNdcsDialogProps) => {
  const count = selectedDrugPackagings.length;
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Remove {count} packaging{count !== 1 ? 's' : ''} from market basket?</DialogTitle>
      <DialogBody>
        <p className="text-sm text-zinc-600">
          This cannot be undone. The following NDC{count !== 1 ? 's' : ''} will be removed:
        </p>
        <ul className="mt-3 max-h-64 divide-y divide-zinc-100 overflow-y-auto rounded-lg border border-zinc-200">
          {selectedDrugPackagings.map((pkg) => (
            <li key={pkg.ndc} className="flex items-baseline gap-3 px-3 py-2.5">
              <span className="shrink-0 font-mono text-xs font-semibold text-zinc-700">{pkg.ndc}</span>
              <span className="truncate text-xs text-zinc-500">{pkg.name}</span>
            </li>
          ))}
        </ul>
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onCancel} disabled={busy}>Cancel</Button>
        <Button color="red" onClick={onSubmit} disabled={busy}>
          <Busy busy={busy} content="Remove"/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
